/* eslint-disable @typescript-eslint/ban-types */
export function getAllPrototypes(Service) {
    const all = [Service];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let obj = Object.getPrototypeOf(Service);
    while (obj && typeof obj === "function" && obj.prototype) {
        all.push(obj);
        obj = Object.getPrototypeOf(obj);
    }
    return all;
}
export function executeArrayMaybePromise(array, toReturn = []) {
    while (array.length) {
        // smh eslint this is safe
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const func = array.shift();
        const val = func();
        if (val instanceof Promise) {
            return val.then((newVal) => {
                toReturn.push(newVal);
                return executeArrayMaybePromise(array, toReturn);
            });
        }
        else {
            toReturn.push(val);
        }
    }
    return toReturn;
}
